// 登录登出
import $ from '../base'

export default {

  // 登录
  login: $.post('login/into'),

  // 验证码
  captcha: $.post('login/captcha'),

  // 用户状态
  status: $.post('login/status'),

  // 登出
  logout: $.post('login/exit')

}
